import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "echarts"
import ECharts from 'vue-echarts'

Vue.component('v-chart', ECharts)

import {EventBus} from './utils/event-bus.js';

Vue.prototype.$bus = EventBus;

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
